module.exports = __webpack_public_path__ + "static/media/howitworks2.5c0525c0.png";